<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex">
				<div class="w-full" v-if="!isLoading">
					<div class="flex">
						<div class="inline-flex">
							<span
								class="border-l border-t border-b font-bold rounded-bl rounded-tl w-16 text-center"
								:class="{ 'bg-sp border-sp text-white': isPriceNet, 'hover:bg-gray-200 cursor-pointer': !isPriceNet }"
								@click="toggleVatPrices('net')"
								>{{ $t('net') }}</span
							>
							<span
								class="border-l border-r border-t border-b font-bold rounded-tr rounded-br w-16 text-center"
								:class="{ 'bg-sp border-sp text-white': !isPriceNet, 'hover:bg-gray-200 cursor-pointer': isPriceNet }"
								@click="toggleVatPrices('gross')"
								>{{ $t('gross') }}</span
							>
						</div>
					</div>

					<div class="flex" style="padding-left: -16px">
						<RentalCarPricingRepairShopForm
							v-if="repairShopPricings"
							ref="rentalCarPricingRepairShopForm"
							:repair-shop-pricings="repairShopPricings"
							:editable="true"
							:selected-rental-car-class="null"
						></RentalCarPricingRepairShopForm>
					</div>
				</div>
				<LoadingSpinner v-else />
			</div>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Authentication from '@/mixins/Authentication';
import RentalCarPricingRepairShopForm from '@/components/rentalcars/forms/RentalCarPricingRepairShopForm.vue';
import { RentalCarsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Validate from '@/mixins/Validate';

export default {
	components: { RentalCarPricingRepairShopForm, LoadingSpinner },
	name: 'OnboardingCompanyRentalCarsPricing',
	mixins: [Validate, Authentication],
	props: {
		value: {
			bankAccount: null,
		},
	},
	data() {
		return {
			repairShopPricings: {},
			repairShopPricingsNet: null,
			repairShopPricingsGross: null,
			isLoading: false,
			isPriceNet: false,
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAuthenticatedUserInGroupAdmin) {
			this.isLoading = true;
			this.loadRepairShopPricing();
		}
	},
	methods: {
		toggleVatPrices(vatType) {
			if (vatType === 'gross') {
				this.isPriceNet = false;
			} else {
				this.isPriceNet = true;
			}
		},
		loadRepairShopPricing() {
			RentalCarsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.rentalcarpricingGet()
				.then(response => {
					if (this.isAuthenticatedUserInGroupAdmin && (this.isUserAllowedInLevel5 || this.isUserAllowedInLevel6)) {
						this.repairShopPricings = response.data.net;
					} else {
						this.repairShopPricings = response.data.gross;
					}
					this.repairShopPricingsNet = response.data.net;

					this.repairShopPricingsGross = response.data.gross;
					this.repairShopPricings = this.repairShopPricingsGross;
					this.isLoading = false;
				})
				.catch(error => {
					this.isLoading = false;
				});
		},
		getData() {
			return this.repairShopPricings;
		},
	},
	watch: {
		isPriceNet() {
			if (this.isPriceNet) {
				this.repairShopPricings = this.repairShopPricingsNet;
			} else {
				this.repairShopPricings = this.repairShopPricingsGross;
			}
		},
	},
};
</script>
